import styled from '@emotion/styled';

export const Container = styled.div((props) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 5,
}));
